import { getSupabase } from '@trader-dashboard/database';
export class ReportsApiService {
    async getEOYSummaryReport(accountId, year, timezone = 'Australia/Sydney') {
        try {
            const supabase = getSupabase();
            // @ts-ignore - RPC function exists but types not generated due to SECURITY DEFINER
            const { data, error } = await supabase.rpc('get_eoy_summary_report', {
                p_account_id: accountId,
                p_year: year,
                p_timezone: timezone,
            });
            if (error) {
                console.error('ReportsApi.getEOYSummaryReport error:', error);
                throw new Error(error.message || 'Failed to load EOY report');
            }
            if (!data) {
                throw new Error('No data returned from EOY report');
            }
            const reportData = typeof data === 'string' ? JSON.parse(data) : data;
            return reportData;
        }
        catch (e) {
            console.error('ReportsApi.getEOYSummaryReport error:', e);
            throw e;
        }
    }
    async getProfitTrends(accountId, timezone = 'Australia/Sydney') {
        const supabase = getSupabase();
        // @ts-ignore - RPC function exists but types not generated due to SECURITY DEFINER
        const { data, error } = await supabase.rpc('get_profit_trends', {
            p_account_id: accountId,
            p_timezone: timezone,
        });
        if (error) {
            console.error('ReportsApi.getProfitTrends error:', error);
            throw new Error(error.message || 'Failed to load profit trends');
        }
        if (!data) {
            throw new Error('No data returned from profit trends');
        }
        const result = typeof data === 'string' ? JSON.parse(data) : data;
        return result;
    }
    async getTaxReport(accountId, year, timezone = 'Australia/Sydney') {
        try {
            const supabase = getSupabase();
            const eoyData = await this.getEOYSummaryReport(accountId, year, timezone);
            const startOfYear = new Date(year, 0, 1, 0, 0, 0).getTime() / 1000;
            const endOfYear = new Date(year, 11, 31, 23, 59, 59).getTime() / 1000;
            const { data: transactions, error: txError } = await supabase
                .schema('trader')
                .from('funds_transactions')
                .select('transaction_time, transaction_type, amount')
                .eq('account_id', accountId)
                .gte('transaction_time', startOfYear)
                .lte('transaction_time', endOfYear)
                .in('transaction_type', ['deposit', 'withdrawal'])
                .order('transaction_time', { ascending: true });
            if (txError) {
                console.error('Error fetching fund transactions:', txError);
                throw new Error(txError.message || 'Failed to load fund transactions');
            }
            const { data: allTransactions, error: allTxError } = await supabase
                .schema('trader')
                .from('funds_transactions')
                .select('amount, transaction_type')
                .eq('account_id', accountId)
                .lte('transaction_time', endOfYear)
                .in('transaction_type', ['deposit', 'withdrawal']);
            if (allTxError) {
                console.error('Error fetching all fund transactions:', allTxError);
            }
            let totalDeposits = 0;
            let totalWithdrawals = 0;
            (allTransactions || []).forEach(tx => {
                if (tx.transaction_type === 'deposit') {
                    totalDeposits += Math.abs(tx.amount);
                }
                else if (tx.transaction_type === 'withdrawal') {
                    totalWithdrawals += Math.abs(tx.amount);
                }
            });
            const endOfYearBalance = totalDeposits - totalWithdrawals + eoyData.totalProfit;
            const fundTransactions = (transactions || []).map(tx => ({
                date: new Date(tx.transaction_time * 1000).toISOString(),
                type: tx.transaction_type,
                amount: Math.abs(tx.amount),
            }));
            return {
                year,
                broker: {
                    name: 'OxSecurities',
                    logo: undefined,
                },
                netProfit: eoyData.totalProfit,
                grossProfit: eoyData.grossProfit,
                commission: eoyData.totalCommission,
                swap: eoyData.totalSwap,
                fundTransactions,
                endOfYearBalance,
            };
        }
        catch (e) {
            console.error('ReportsApi.getTaxReport error:', e);
            throw e;
        }
    }
}
// Create singleton instance
const reportsApiService = new ReportsApiService();
// Export singleton
export const ReportsApi = reportsApiService;
